import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPreloaderIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "64px",
	height: "64px",
	viewBox: "0 0 128 128",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#2fa855",
			fillOpacity: 1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(30 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(60 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(90 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(120 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(150 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(180 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eaf6ee",
			fillOpacity: .1,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(210 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d5eedd",
			fillOpacity: .2,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(240 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#acdcbb",
			fillOpacity: .4,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(270 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#82cb99",
			fillOpacity: .6,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(300 64 64)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#59b977",
			fillOpacity: .8,
			d: "M70.48 35.8l-6.16-6.24-6.16 6.26L64.32.88z",
			transform: "rotate(330 64 64)"
		}),
		/* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
			calcMode: "discrete",
			dur: "1320ms",
			repeatCount: "indefinite"
		})
	] })
});
export default SvgPreloaderIcon;
